function factorial(n) {
  let nf = 1;
  for (let i = 1; i <= n; i++) {
    nf *= i;
  }
  return nf;
}

const C = (a, b) => factorial(b) / (factorial(a) * factorial(b - a));
export const P = (w, n, x) => ((C(x, w) * C(w - x, n - w)) / C(w, n)) * 100;

// let c40 = [
//   [0.4, 2.75],
//   [0, 1.8, 5.1],
//   [0, 0, 2.8, 50],
//   [0, 0, 1.7, 10, 100],
//   [0, 0, 1.4, 4, 14, 390],
//   [0, 0, 0, 3, 9, 180, 710],
//   [0, 0, 0, 2, 7, 30, 400, 800],
//   [0, 0, 0, 2, 4, 11, 67, 400, 900],
//   [0, 0, 0, 2, 2.5, 5, 15, 100, 500, 1000],
//   [0, 0, 0, 1.6, 2, 4, 7, 26, 100, 500, 1000],
// ];

export const p40 = [
  [75, 25],
  [55.76923077, 38.46153846, 5.769230769],

  [41.09311741, 44.02834008, 13.66396761, 1.214574899],
  [29.98686946, 44.42499179, 21.41919247, 3.939161834, 0.2297844403],
  [
    21.6571835,
    41.64842981,
    27.76561987,
    7.933034249,
    0.957435168,
    0.03829740672,
  ],
  [
    15.46941679,
    37.12660028,
    32.12878871,
    12.6928548,
    2.379910275,
    0.1969580917,
    0.005471058103,
  ],
  [
    10.91958832,
    31.84879926,
    34.3967032,
    17.63933498,
    4.57316092,
    0.5879778326,
    0.03379182946,
    0.000643653894,
  ],
  [
    7.610622162,
    26.47172926,
    34.74414465,
    22.23625258,
    7.483354233,
    1.330374086,
    0.1187834005,
    0.004681119232,
    0.00005851399,
  ],
  [
    5.232302736,
    21.40487483,
    33.50328234,
    26.05810849,
    10.94440557,
    2.525632053,
    0.3118064264,
    0.01909018937,
    0.000493711794,
    0.000003657124,
  ],
  [
    3.544463144,
    16.87839592,
    31.07159249,
    28.82002782,
    14.71022253,
    4.23654409,
    0.6789333477,
    0.05747583896,
    0.002309297101,
    0.000035391526,
    0.000000117972,
  ],
];

export const p80 = [
  [75, 25],
  [56.01265823, 37.97468354, 6.012658228],
  [41.65043817, 43.08666018, 13.87536514, 1.387536514],
  [30.83214254, 43.27318251, 21.26354658, 4.324789135, 0.3063392304],
  [
    22.71842082,
    40.56860861,
    27.04573907,
    8.393505229,
    1.209233804,
    0.06449246956,
  ],
  [
    16.66017527,
    36.34947331,
    30.83214254,
    12.98195475,
    2.853791778,
    0.3095638539,
    0.01289849391,
  ],
  [
    12.1574252,
    31.51925051,
    32.66540507,
    17.49932414,
    5.219096675,
    0.8638504841,
    0.07320766814,
    0.002440255605,
  ],
  [
    8.826623772,
    26.64641139,
    32.81456217,
    21.47862251,
    8.15037015,
    1.83025856,
    0.2366713655,
    0.01604551631,
    0.000434566067,
  ],
  [
    6.374783835,
    22.06655943,
    31.64261352,
    24.61092163,
    11.41051821,
    3.26014806,
    0.5719558,
    0.05916784138,
    0.0032592455,
    0.000072427678,
  ],
  [
    4.579070079,
    17.95713756,
    29.52567811,
    26.74023678,
    14.73188971,
    5.142768771,
    1.147939458,
    0.1611143099,
    0.01354193553,
    0.000612064883,
    0.00001122119,
  ],
];
